import { render, staticRenderFns } from "./EventsIndexHeader.vue?vue&type=template&id=b0049832&"
import script from "./EventsIndexHeader.vue?vue&type=script&lang=js&"
export * from "./EventsIndexHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports